import { useEffect, useState } from "react";
import { DataTable } from "../../../DataTable/DataTable";
import { AdminDriverService } from "../../../../services/api/AdminOrderService/admin.driver.service";
import defaultAvatar from "../../../../assets/images/default_avatar.jpg";
import { ClinicDriverService } from "../../../../services/api/clinic.driver.service";
import { useDriver } from "../../Clinic/Driver/DriverContext";
import { AdminDriverDetails } from "./AdminDriverDetail";
import { Edit3, Eye } from "lucide-react";

export interface AdminDeliveryAgentInterface {
  id: string;
  clinicId: string;
  profilePicture?: string;
  education?: string;
  dateOfBirth?: string;
  address?: string;
  aadharFrontImage?: string;
  aadharBackImage?: string;
  dlFrontImage?: string;
  dlBackImage?: string;
  vehicleRcFront?: string;
  vehicleRcBack?: string;
  vehicleBrand?: string;
  vehicleNumber?: string;
  drivingLicence?: string;
  vehicleInsurance?: string;
  blocked?: boolean;
  isAvailable?: boolean;
  lastOrderTime?: string;
  type?: string;
  createdAt?: string;
  updatedAt?: string;
  role?: string;
  name: string;
  aadharNumber?: string;
  mobileNumber: string;
  email?: string;
  username?: string;
  password?: string;
}

export function DeliveryBoy({handleViewButton}) {
  const [isLoading, setIsLoading] = useState(true);
  const [driverList, setDriverList] = useState<AdminDeliveryAgentInterface[]>(
    []
  );
  const [selectedDriver, setSelectedDriver] =
    useState<AdminDeliveryAgentInterface | null>(null);
    const[pageSize,setPageSize]=useState(10);
    const [currentPage, setCurrentPage] = useState(1);
  const { dispatch } = useDriver();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  });

  const fetchDrivers = async () => {
    try {
      setIsLoading(true);
      const response = await AdminDriverService.getDriverListing(
        pagination.page,
        pageSize,
        { type: "driver" }
      );

      if (response.data) {
        setDriverList(response.data || []);
        setPagination({
          ...pagination,
          totalCount: response.pagination.totalItems,
          totalPages: response.pagination.totalPages,
          
        });
        setCurrentPage(response.pagination.currentPage)
      }
    } catch (error) {
      console.error("Failed to fetch drivers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, [pagination.page, pageSize]);


  const handlePageChange = (page: number) => {
    setPagination({ ...pagination, page });
  };

  const handleCloseSummaryForm = () => {
    setSelectedDriver(null);
    dispatch({ type: "CLOSE_FORM" });
  };

  const columns = [
    {
      key: "name",
      title: "Driver Name",
      sortable: true,
      width: "w-[200px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="flex items-center">
          <img
            src={driver.profilePicture || defaultAvatar}
            alt={driver.name}
            className="w-8 h-8 rounded-full mr-3 object-cover border border-gray-200"
          />
          <div className="font-medium text-gray-900">{driver.name}</div>
        </div>
      ),
    },
    {
      key: "mobileNumber",
      title: "Phone Number",
      width: "w-[150px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.mobileNumber}</div>
      ),
    },
    {
      key: "email",
      title: "Email",
      width: "w-[200px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.email || 'N/A'}</div>
      ),
    },
    {
      key: "vehicleBrand",
      title: "Vehicle Brand",
      width: "w-[150px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.vehicleBrand || 'N/A'}</div>
      ),
    },
    {
      key: "vehicleNumber",
      title: "Vehicle Number",
      width: "w-[150px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="text-sm font-medium">{driver.vehicleNumber || 'N/A'}</div>
      ),
    },
    {
      key: "status",
      title: "Status",
      width: "w-[100px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="text-sm font-medium">
          {driver.blocked ? (
            <span className="text-red-500">Blocked</span>
          ) : driver.isAvailable ? (
            <span className="text-green-500">Available</span>
          ) : (
            <span className="text-yellow-500">Busy</span>
          )}
        </div>
      ),
    },
    {
      key: "actions",
      title: "Actions",
      width: "w-[200px]",
      render: (driver: AdminDeliveryAgentInterface) => (
        <div className="flex items-center gap-4">
          
          <button
            className="text-green-600 hover:text-green-700"
            onClick={() => {
              handleViewButton(driver.id);
            }}
          >
            <Eye className="w-5 h-5" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        data={driverList}
        columns={columns}
        isLoading={isLoading}
        pagination={{
          currentPage: pagination.page,
          totalPages: pagination.totalPages,
          setCurrentPage: handlePageChange,
          pageSize,
          setPageSize,
        }}
        // pagination={{
        //     currentPage,
        //     setCurrentPage,
        //     setTotalPages,
        //     totalPages,
        //     pageSize,
        //     setPageSize,
        //   }}
      />
      {selectedDriver && (
        <AdminDriverDetails
          driver={selectedDriver}
          onCancel={handleCloseSummaryForm}
        />
      )}
    </>
  );
}
